
<template>
  <div id="app">
	  <van-tabs v-model="active" @click="setName"  line-height="0px" title-active-color="rgb(255, 195, 0)" >
	    <van-tab v-for="info in infos.category">
	       <div slot="title">
			   <div class="item-title">
				   <img :src="info.image" alt="" style="width: 2.5rem;height: 2.5rem;">
				   {{info.name}}
			   </div>
			   
	       </div>
	       <div style="padding: 0 1rem;">
			   <div class="c-content" v-on:click="go(coupon.coupon_url)" v-if="info.id==coupon.category_id||info.id==0"  v-for="coupon in infos.coupons">
				   <div class="c-cart">
					   <img :src="coupon.image" alt="666" class="c-img">
					   <div class="c-sign">
						   <span style="font-size: 0.8rem;">{{coupon.name}}</span>
						   <p>{{coupon.des}}</p>
					   </div>
					   <div class="coupon-midline badge"></div>
					   <div class="c-l" >
						   领取
					   </div>
				   </div>
				   
			   </div>
			   
		   </div>
	     </van-tab>
	  </van-tabs>
  </div>
</template>

<script>
	import Vue from 'vue';
	import Vant from 'vant';
	import 'vant/lib/index.css';
	import axios from 'axios';
	Vue.use(Vant);
	
	export default {
	  data() {
	    return {
	      active: 0,
		  infos:{},
		  path:'all'
	    };
	  },
	  created:function(){
		this.path = this.$route.params.path
	  	this.getData()
	  },

	  methods:{
	  	go: function(e){
	  		window.location.href=e
	  		
	  	},
		getData:function(){
			var that = this
			 axios.get('/index.php/api/coupon/getcoupons.html')
			 .then(resp=>{
			         that.infos = resp.data.data
					 var category = resp.data.data.category
					 for(var i = 0;i<category.length;i++){
						 if(category[i].nickname==that.path){
							 that.active = i
						 }
						 
					 }
			         }).catch(resp=>{
			         console.log('请求失败:'+err.status+','+err.statusText);
			          });
			
		},
		setName:function(e){
			
			document.title = this.infos.category[e].name
			var path = this.infos.category[e].nickname
			this.$router.push({
				path:'/'+path
			})
		}
	  }
	}
	
	
   
	
</script>

<style>
.item-title{
	height: 5rem;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	padding-top: .3rem;
	line-height: 1.5rem;
	font-size: .8rem;
}	
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  color: #2c3e50;
  
}
.van-tabs--line .van-tabs__wrap {
    height: 5rem;
}
.c-content{
	background: #fff;
	height: 5rem;
	width: 100%;
	border-radius: .08rem;
	margin-top: 1rem;
}
.c-cart{
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	
	width: 15rem;
	height: 100%;
}
.c-img{
	width: 2.5rem;
	height: 2.5rem;
	margin-left: 1rem;
}
.c-sign{
	margin-top:1rem;
	margin-left: 1rem;
}
.c-sign p {
    font-size: 1rem;
    color: #f10404;
    margin-top: .7rem;
}
.coupon-midline {
    width: .3rem;
    height: 5rem;
    position: absolute;
    z-index: 9999;
    border-right: 1px dashed #f6f6f6;
	right: 6rem;
}
.badge:before {
    top: -.2rem;
}
.badge::after{
	bottom: -.2rem;
}
.badge:after, .badge:before {
    content: "";
    position: absolute;
    width: 0.7rem;
    height: 0.7rem;
    
    left: 0rem;
    background-color: #ECECEC;
    border-radius: 50%;
}
.c-l{
	position: absolute;	
	color: rgb(255, 195, 0);
	font-size: 1.2rem;
	right: 2.3rem;
}


html{
	background: #ECECEC;
}
</style>
